import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Upload, X } from "lucide-react";
import Imports from "@/pages/Imports";

export const ImportButton = ({ only, label = "Ανέβασμα αρχείου" }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!["owner", "hr", "manager"].includes(user?.role)) return null;
  return (
    <>
      <button data-testid={`import-btn-${only.join("-")}`} onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-xl border border-[#E3DED4] bg-white px-4 py-2.5 text-sm font-semibold text-[#45423C] hover:border-[#45423C]">
        <Upload className="h-4 w-4" /> {label}
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 overflow-y-auto" onClick={() => setOpen(false)} data-testid="import-dialog">
          <div className="bg-[#F7F5F1] rounded-2xl w-full max-w-5xl my-6 p-5" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-end"><button data-testid="import-dialog-close" onClick={() => setOpen(false)} className="p-1.5 rounded-lg hover:bg-white"><X className="h-5 w-5" /></button></div>
            <Imports only={only} embedded />
          </div>
        </div>
      )}
    </>
  );
};
